<template>
  <transition name="modal" v-if="type !== 'none'">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
              {{ titleText }}
            </slot>
          </div>
          <div class="modal-body">
            <div class="msg-box">{{ text }}</div>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <div class="modal-default-footer">
                <button v-if="useYes" class="modal-default-button" @click="$emit('yes')">
                  {{ yesButtonText }}
                </button>
                <button v-if="useNo" class="modal-default-button" @click="$emit('no')">
                  {{ noButtonText }}
                </button>
                <button v-if="useCancel" class="modal-default-button" @click="$emit('close')">
                  {{ cancelButtonText }}
                </button>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import Modal from '@/components/Modal.vue'

const types = Object.freeze({
  'none': -1,
  'alert': 0,
  'confirm': 1,
  'message': 2,
});

export default {
  name: 'MsgDialog',
  extends: Modal,
  props: {
    type: {
      type: String,
      default: 'none',
      validator: v => types[v] !== undefined,
    },
    title: {
      type: String,
    },
    text: {
      type: String,
    },
    yes: {
      type: Boolean,
      default: true,
    },
    no: {
      type: Boolean,
      default: false,
    },
    cancel: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
  },
  computed: {
    titleText(){
      return this.title||this.$t(`msgDialog.default.title.${this.type}`);
    },
    yesButtonText(){
      return this.yesText||this.$t('msgDialog.default.button.yes');
    },
    noButtonText(){
      return this.noText||this.$t('msgDialog.default.button.no');
    },
    cancelButtonText(){
      return this.cancelText||this.$t('msgDialog.default.button.cancel');
    },
    useYes(){
      if(this.type==='message'){
        return this.yes;
      }else{
        return true;
      }
    },
    useNo(){
      let result = false;
      switch (this.type) {
        case 'message':
          result = this.no;
          break;
        case 'alert':
          result = false;
          break;
        case 'confirm':
          result = true;
          break;
        default:
          result = false;
      }
      return result;
    },
    useCancel(){
      return this.cancel;
    },
  },
};
</script>
<style lang="scss" scoped>
  .modal-body {
    min-height: 100px;
    .msg-box {
      padding: 10px 20px;
      white-space: pre-line;
    }
  }
  .modal-default-footer{
    padding: 5px 10px 10px 10px;
    display: flex;
    justify-content:flex-end;

    button {
      padding: 0px 10px;
    }
  }
</style>
